import './ColorButton.css'
import React, { useState, useRef } from 'react'

export default function SecondaryToolbarButton({
  ariaLabel,
  children,
  className,
  onClick,
  title
}) {
  const [isHovered, setIsHovered] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const button = useRef(null)

  const handleClick = () => {
    onClick()
    button.current.focus()
  }

  return (
    <button
      className={className}
      onClick={handleClick}
      onTouchStart={() => setIsHovered(true)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      aria-label={ariaLabel}
      title={title}
      ref={button}
    >
      {children({ isHovered, isFocused })}
    </button>
  )
}
